module.exports = __webpack_public_path__ + "img/es.2b7627ca.svg";